export default {"src":"/_next/static/media/intrusion-detection.3b63be44.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};